import React, { forwardRef, MouseEvent, useMemo } from 'react';
import { OriginalsSelection, SelectionMovie } from '@funtech-int/kp-graphql-sdk/yango-movies-www';
import { Route, RouterLocation } from '@funtech-int/rival';
import classnames from 'classnames';

import { Carousel } from '../Carousel/Carousel';
import * as Card from '../Card';

import { SelectionTitle } from './_SelectionTitle';
import styles from './_Originals.module.css';

interface OriginalsProps {
    selection: OriginalsSelection;
    location: RouterLocation<any, any>;
    movieRoute: Route<any, { id: string }, any>;
    className?: string;
    onHeaderClick?(): void;
    onShowAllClick?(): void;
    onCardShow?(item: SelectionMovie, index: number): void;
    onCardClick?(item: SelectionMovie, index: number): void;
}

export const Originals = forwardRef<HTMLDivElement, OriginalsProps>(
    (
        {
            selection,
            location,
            movieRoute,
            className,
            onHeaderClick,
            onShowAllClick,
            onCardShow,
            onCardClick,
        },
        ref
    ) => {
        const searchParams = useMemo(() => new URLSearchParams(), []);

        if (selection.showcaseId) {
            searchParams.set('selectionWindowId', selection.showcaseId);
        }

        return (
            <div
                ref={ref}
                className={classnames(styles.root, className)}
                data-tid="OriginalsSelection"
            >
                <SelectionTitle
                    title={selection.title}
                    location={location}
                    searchParams={searchParams}
                    className={styles.title}
                    iconClassName={styles.titleLinkIcon}
                    onClick={onHeaderClick}
                />
                <Carousel className={styles.carousel}>
                    {selection.items.map((item, index) => {
                        const { movie } = item;

                        const handleCardShow = () => {
                            onCardShow?.(movie, index);
                        };

                        const handleCardClick = (e: MouseEvent<HTMLAnchorElement>) => {
                            e.preventDefault();
                            onCardClick?.(movie, index);
                        };

                        return (
                            <Card.Original
                                key={movie.contentId}
                                entity={item}
                                location={movieRoute({ id: movie.contentId })}
                                onShow={handleCardShow}
                                onClick={handleCardClick}
                            />
                        );
                    })}
                    {selection.hasMore && (
                        <Card.ShowAll
                            location={location}
                            searchParams={searchParams}
                            onClick={onShowAllClick}
                        />
                    )}
                </Carousel>
            </div>
        );
    }
);
